import React from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import {Helmet} from 'react-helmet';
import {Toaster} from './components/ui/toaster';
import {AuthProvider} from './contexts/PhpAuthContext';
import {DataProvider} from './contexts/DataContext';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AdminLoginPage from './pages/AdminLoginPage';
import PatientLoginPage from './pages/PatientLoginPage';
import RegisterPage from './pages/RegisterPage';
import PatientDashboard from './pages/PatientDashboard';
import DoctorDashboard from './pages/DoctorDashboard';
import AdminDashboard from './pages/AdminDashboard';
import ClinicLoginDashboard from './pages/ClinicLoginDashboard';
import PatientForm from './pages/PatientForm';
import ProtectedRoute from './components/ProtectedRoute';

function App () {
  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <Helmet>
            <title>Gugan Dental Care - Modern Dental Practice Management</title>
            <meta
              name="description"
              content="Comprehensive electronic health records system for dental practices with patient portal, doctor management, and admin controls."
            />
          </Helmet>
          <div className="min-h-screen">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/patient/login" element={<PatientLoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route
                path="/patient/dashboard"
                element={
                  <ProtectedRoute allowedRoles={['patient']}>
                    <PatientDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/patient/form"
                element={
                  <ProtectedRoute allowedRoles={['patient']}>
                    <PatientForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/doctor/dashboard"
                element={
                  <ProtectedRoute allowedRoles={['doctor', 'chief_doctor']}>
                    <DoctorDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute allowedRoles={['admin']}>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clinic/dashboard"
                element={
                  <ProtectedRoute allowedRoles={['clinic_login']}>
                    <ClinicLoginDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
            <Toaster />
          </div>
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;
